import { ACCESS_TOKEN } from '@src/constants';
import { AuthUser } from '@src/types';
import Cookies from 'js-cookie';
import { create } from 'zustand';

interface AuthState {
  auth: {
    user: AuthUser | null;
    accessToken: string;
    setUser: (user: AuthUser | null) => void;
    setAccessToken: (accessToken: string) => void;
    resetAccessToken: () => void;
    reset: () => void;
  };
}

export const useAuthStore = create<AuthState>()((set) => {
  const cookieState = Cookies.get(ACCESS_TOKEN);

  return {
    auth: {
      user: null,
      accessToken: cookieState ?? '',
      setUser: (user) =>
        set((state) => ({
          ...state,
          auth: {
            ...state.auth,
            user: {
              ...user,
              username: `${user?.first_name ?? ''}${user?.first_name ? ' ' : ''}${user?.last_name ?? ''}`,
            },
          },
        })),
      setAccessToken: (accessToken) =>
        set((state) => {
          Cookies.set(ACCESS_TOKEN, accessToken);

          return { ...state, auth: { ...state.auth, accessToken } };
        }),
      resetAccessToken: () =>
        set((state) => {
          Cookies.remove(ACCESS_TOKEN);

          return { ...state, auth: { ...state.auth, accessToken: '' } };
        }),
      reset: () =>
        set((state) => {
          Cookies.remove(ACCESS_TOKEN);

          return {
            ...state,
            auth: { ...state.auth, user: null, accessToken: '' },
          };
        }),
    },
  };
});
